import { html, TemplateResult, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import globalStyles from './styles/outline-title-block.global.pcss?inline';
import encapsulatedStyles from './styles/outline-title-block.base.pcss?inline';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import { SlotHelper } from '../../controllers/slot-helper';

const componentName = 'outline-title-block';

/**
 * The OutlineTitleBlock component
 * @element outline-title-block
 */
@customElement('outline-title-block')
export class OutlineTitleBlock extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
    encapsulatedCSS: encapsulatedStyles,
  });
  private _slotHelper = new SlotHelper(this);

  @property({ type: Boolean })
  hasHeading: boolean;
  @property({ type: Boolean })
  hasDescription: boolean;
  @property({ type: Boolean })
  hasAuthor: boolean;
  @property({ type: Boolean })
  hasDate: boolean;
  @property({ type: Boolean })
  hasRead: boolean;
  @property({ type: Boolean })
  hasShare: boolean;

  render(): TemplateResult {
    this.hasHeading = this._slotHelper.isNotEmpty('heading');
    this.hasDescription = this._slotHelper.isNotEmpty('description');
    this.hasAuthor = this._slotHelper.isNotEmpty('author');
    this.hasDate = this._slotHelper.isNotEmpty('date');
    this.hasRead = this._slotHelper.isNotEmpty('read');
    this.hasShare = this._slotHelper.isNotEmpty('share');

    return html`
      <section class="outline-title-block">
        <div class="outline-title-block--header">
          <div class="heading-wrapper">
            <slot name="heading"></slot>
          </div>
          ${this.descriptionTemplate()}
        </div>
        <div class="outline-title-block--info-sharing-wrapper">
          <div class="outline-title-block--info">
            ${this.authorTemplate()}
            <div class="outline-title-block--stats">
              ${this.dateTemplate()}
              ${this.readTemplate()}
            </div>
          </div>
          <div class="outline-title-block--sharing">
            ${this.shareTemplate()}
          </div>
        </div>
      </section>
    `;
  }

  descriptionTemplate() {
    if(this.hasDescription) {
      return html `<div class="description-wrapper"><slot name="description"></slot></div>`
    } else {
      return;
    }
  }
  authorTemplate() {
    if(this.hasAuthor) {
      return html `<div class="author-wrapper"><slot name="author"></slot></div>`
    } else {
      return;
    }
  }
  dateTemplate() {
    if(this.hasDate) {
      return html `<div class="date-wrapper"><slot name="date"></slot></div>`
    } else {
      return;
    }
  }
  readTemplate() {
    if(this.hasRead) {
      return html `<div class="read-wrapper"><slot name="read"></slot></div>`
    } else {
      return;
    }
  }
  shareTemplate() {
    if(this.hasShare) {
      return html `<div class="social-share-wrapper">
        <span>Share this article</span>
        <slot name="share"></slot>
        </div>`
    } else {
      return;
    }
  }
}

/**
 * Declare the component in the global HTMLElementTagNameMap
 */
declare global {
  interface HTMLElementTagNameMap {
    [componentName]: OutlineTitleBlock;
  }
}
